import BaseApi from 'api/core/baseApi';
import { ENDPOINTS } from 'api/config/endpoints';

class ShipmentApi extends BaseApi {
  constructor() {
    super(ENDPOINTS.SHIPMENT);
  }

  shipmentUpdate(shipmentId, data) {
    return this.httpClient.patch(
      `${this.getResourceUrl()}${shipmentId}/detail/`,
      data,
    );
  }

  getShipmentsForCreatePicklist(params = new URLSearchParams()) {
    const queryString = params.toString();
    const url = queryString
      ? `${this.getResourceUrl()}picklists/?${queryString}`
      : `${this.getResourceUrl()}picklists/`;

    return this.httpClient.get(url);
  }

  getShippingProviders(params = {}) {
    return this.httpClient.get(`${this.getResourceUrl()}shipping-providers/`, {
      params,
    });
  }

  getShippingCouriers(shippingProviderId) {
    return this.httpClient.get(
      `${this.getResourceUrl()}${shippingProviderId}/shipping-couriers/`,
    );
  }

  getInvoices(orderId) {
    return this.httpClient.get(`${this.getResourceUrl()}${orderId}/invoices/`);
  }

  getReturns(orderId, params = new URLSearchParams()) {
    const queryString = params.toString();
    const url = queryString
      ? `${this.getResourceUrl()}${orderId}/returned/?${queryString}`
      : `${this.getResourceUrl()}${orderId}/returned/`;

    return this.httpClient.get(url);
  }

  getInvoiceDetail(shipmentId) {
    return this.httpClient.get(
      `${this.getResourceUrl()}${shipmentId}/invoice-detail/`,
    );
  }

  exportShipment(params = new URLSearchParams()) {
    const queryString = params.toString();
    const url = queryString
      ? `${this.getResourceUrl()}export/?${queryString}`
      : `${this.getResourceUrl()}export/`;

    return this.httpClient.get(url);
  }

  refreshShipment(shipmentId) {
    return this.httpClient.patch(
      `${this.getResourceUrl()}${shipmentId}/refresh-shipping/`,
      {},
    );
  }
}

export default new ShipmentApi();
